module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"switchIsTemporaryLabel":"Rendre ce lieu temporaire","startDateLabel":"Date de début","startTimeLabel":"Heure de début","endDateLabel":"Date de fin","endTimeLabel":"Heure de fin"},"en":{"switchIsTemporaryLabel":"Make this POI temporary","startDateLabel":"Start date","startTimeLabel":"Start time","endDateLabel":"End date","endTimeLabel":"End time"}}')
  delete Component.options._Ctor
}
